import { cn } from 'common/utils';

// Post Type Icons
export const FreePostIcon = ({
  className,
  iconClassName,
}: {
  className?: string;
  iconClassName?: string;
}) => {
  return (
    <div
      className={cn(
        'border-[1.5px relative flex shrink-0 items-center justify-center rounded-full',
        className,
      )}
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <svg
          viewBox="0 0 20 20"
          fill="currentColor"
          className={iconClassName ?? 'size-4 text-pp-text-secondary'}
        >
          <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm4.89 7.11l-5.5 5.5a1 1 0 01-1.42 0l-2.5-2.5a1 1 0 111.42-1.42L8.39 10.18l4.79-4.79a1 1 0 111.42 1.42z" />
        </svg>
      </div>
    </div>
  );
};

export const PostTypeIconWithText = ({
  className,
  text,
}: {
  text: string;
  className: string;
}) => {
  return (
    <div
      className={cn(
        'relative flex shrink-0 items-center justify-center rounded-full border-[1.5px] border-gray-800 font-bold text-gray-800',
        className ?? 'size-7 text-[11px]',
      )}
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap">
        {text}
      </div>
    </div>
  );
};
